<template>

  <div class="root" @click="cellClick" v-if="infoUi">

    <!--头部-->
    <van-row class="header">
      <van-col class="headerLeft" span="12">订单号:{{infoUi.orderSn}}</van-col>
      <van-col class="headerRight" span="12"><span style="color: red;">{{infoUi.uiOrderStatusText}}</span></van-col>
      <!-- <van-col class="headerArrow" span="2">
        <van-icon name="arrow" />
      </van-col> -->
    </van-row>

    <!--订单商品列表-->
    <!-- <van-row class="content" v-for="(item,index) in infoUi.goodsList" :key="index">
      <van-col span="6" style="text-align: left;">
        <van-image width="80" height="80" :src="item.picUrl" />
      </van-col>

      <van-col span="18" style="height: 80px;text-align: left;">

        <van-row style="height: 4rem;"> {{item.goodsName}} </van-row>
        <van-row style="height: 20px;"> {{item.number}}/件 </van-row>
        <van-row style="height: 20px;"> ￥2324 </van-row>

      </van-col>
    </van-row> -->
    <van-card class="product-list" v-for="(item,index) in infoUi.goodsList" :key="index" :thumb="item.picUrl">
      <template #desc>
        <div class="product-item">
          <div class="select-data">{{item.goodsName}}</div>
          <!-- <div class="select-guige">
            <div class="select-guige-item" v-for="(goods,idx) in item.specifications" :key="idx">{{goods}}</div>
          </div> -->
          <div class="price-number">
            <div>￥{{item.priceui}}</div>
            <div>x{{item.number}}</div>
          </div>

        </div>

      </template>
    </van-card>
    <!--底部-->
    <div class="bottem">
      <div class="headerLeft">实付:<span style="font-weight: bold;">￥{{infoUi.uiactualPrice}}</span></div>
      <div class="headerRight bottom-h">
        <div v-if="infoUi.handleOption.cancel" @click.stop="cancelOrder" class="btn nobg ">取消订单</div>
        <div v-if="infoUi.handleOption.pay" class="btn">立即付款</div>
        <div v-if="infoUi.handleOption.delete" @click.stop="deleteOrder" class="btn  nobg">删除订单</div>

        <div v-if="infoUi.handleOption.confirm" @click.stop="confirmOrder" class="btn">确认收货</div>

        <!-- <div v-if="infoUi.handleOption.comment" class="btn">查看评价</div> -->
        <div v-if="infoUi.handleOption.comment" @click.stop="navToOrderGoods" class="btn">评价商品</div>
        <!-- <div v-if="infoUi.handleOption.rebuy" class="btn">再次购买</div> -->
        <div v-if="infoUi.handleOption.refund" @click.stop="refundOrder" class="btn">申请退款</div>

      </div>
    </div>

  </div>

</template>

<!--
 订单列表中的cell组件
 create by zcg at 2020年4月4日14:15:58
 -->

<script>
import {
  orderDelete,
  orderCancel,
  orderRefund,
  orderConfirm
} from "@/api/index";
import { Dialog, Toast } from "vant";
export default {
  name: "ordercell",
  props: {
    info: {
      //订单信息
      type: Object
    }
  },
  data() {
    return {
      infoUi: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      let key = this.info.orderStatusText;
      this.info.uiOrderStatusText = "";
      switch (key) {
        case "已取消(系统)":
          this.info.uiOrderStatusText = "已取消";
          break;
        case "未付款":
          this.info.uiOrderStatusText = "等待付款";

          break;
        case "已付款":
          this.info.uiOrderStatusText = "等待发货";

          break;
        case "已发货":
          this.info.uiOrderStatusText = "等待收货";

          break;
        case "已收货":
          this.info.uiOrderStatusText = "等待评价";

          break;
        case "交易完成":
          this.info.uiOrderStatusText = "交易完成";

          break;
        case "订单取消，退款中":
          this.info.uiOrderStatusText = "等待退款";

          break;
        case "已退款":
          this.info.uiOrderStatusText = "交易关闭";
          break;
        default:
          this.info.uiOrderStatusText = key;
          break;
      }
      this.info.goodsList.forEach(element => {
        element.priceui = element.price.toFixed(2);
      });
      this.infoUi = JSON.parse(JSON.stringify(this.info));
    });
  },

  methods: {
    navToOrderGoods() {
      console.log(this);
      this.$router.push({
        path: "/myorderdetail",
        query: {
          id: this.info.id
        }
      });
    },
    confirmOrder() {
      let data = {
        orderId: this.info.id
      };
      Dialog.confirm({
        title: "提示",
        message: "确认收货？"
      })
        .then(() => {
          // on confirm
          orderConfirm(data).then(res => {
            if (res.data.errno == 0) {
              Toast("成功收货");
              this.$emit("updataList", true);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    refundOrder() {
      console.log(this.info);
      let data = {
        orderId: this.info.id
      };
      Dialog.confirm({
        title: "提示",
        message: "确认申请退款？"
      })
        .then(() => {
          // on confirm
          orderRefund(data).then(res => {
            if (res.data.errno == 0) {
              // let refundData = {
              //   orderId: this.info.id,
              //   orderPrice: this.info.actualPrice
              // };
              // if (this.info.payType == "zfb") {
              // aliRefund(refundData).then(aliRes => {
              //   console.log(aliRes);
              // });
              Toast("退款成功");

              this.$emit("updataList", true);
              // } else {
              // wxRefund(refundData).then(aliRes => {
              //   console.log(aliRes);
              // });
              //   this.$emit("updataList", true);
              // }
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    cancelOrder() {
      let data = {
        orderId: this.info.id
      };
      Dialog.confirm({
        title: "提示",
        message: "确认取消该订单？"
      })
        .then(() => {
          // on confirm
          orderCancel(data).then(res => {
            if (res.data.errno == 0) {
              Toast("取消成功");
              this.$emit("updataList", true);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    deleteOrder() {
      let data = {
        orderId: this.info.id
      };
      Dialog.confirm({
        title: "提示",
        message: "确认删除该订单？"
      })
        .then(() => {
          // on confirm
          orderDelete(data).then(res => {
            if (res.data.errno == 0) {
              Toast("删除成功");
              this.$emit("updataList", true);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    cellClick() {
      this.$emit("click", this.info); //将订单信息将参数传递出去
    }
  }
};
</script>

<style scoped lang="scss">
.root {
  background-color: white;
  padding: 0px 10px;
  margin-top: 10px;
  box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
  border-radius: 8px;
}

.header {
  height: 4rem;

  .headerLeft {
    text-align: left;
    opacity: 0.5;
    font-family: PingFangSC-Regular;
    font-size: 1.3rem;
    color: #424242;
    line-height: 4rem;
  }

  .headerRight {
    text-align: right;
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #fe5845;
    text-align: right;
    line-height: 4rem;
  }

  .headerArrow {
    background-color: transparent;
    height: 100%;
    font-size: 1.5rem;
    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
  }
}

.content {
  padding: 5px 0px;
  border-bottom: solid 1px lightgrey;
}

.bottem {
  padding-bottom: 1.6rem;

  .headerLeft {
    text-align: right;
    font-family: PingFangSC-Regular;
    font-size: 1.4rem;
    color: #424242;
    letter-spacing: 0;
    line-height: 1.6rem;
    margin-right: 1rem;
  }

  .headerRight {
    text-align: right;
    margin: 2.4rem 0 0;
  }
  .bottom-h {
    display: flex;
    padding: 0 1rem;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    .btn {
      padding: 0 1rem;
      height: 3rem;
      line-height: 3rem;
      min-width: 8.8rem;
      text-align: center;
      border: 1px solid #e0e1e0;
      border-radius: 1.6rem;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #a8a8a8;
      letter-spacing: 0;
      text-align: center;
      line-height: 3rem;
      box-sizing: border-box;
    }
    .btn:last-child {
      background: #d6be93;
      border-radius: 1.6rem;
      font-family: PingFangSC-Regular;
      font-size: 1.4rem;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 3rem;
      margin-left: 1.2rem;
      border: 1px solid #e0e1e0;
    }
    .nobg {
      border: 1px solid #e0e1e0 !important;
      color: #a8a8a8 !important;
      background: #fff !important;
    }
  }
}
/deep/ .van-image__error,
.van-image__img,
.van-image__loading {
  border-radius: 4px;
}
.product-list {
  background: #fff;
  .product-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .select-data {
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #424242;
      line-height: 1.4rem;
      padding-left: 1rem;
      text-align: left;
    }
    .select-guige {
      background: #f7f7f7;
      border-radius: 2px;
      padding: 0.6rem;
      display: inline-block;
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #9c9c9c;
      letter-spacing: 0;
      line-height: 1.2rem;
      margin-left: 1rem;
      margin-top: 0.8rem;
    }
    .price-number {
      display: flex;
      justify-content: space-between;
      margin-top: 1.6rem;
      padding-left: 1rem;
      box-sizing: border-box;
      width: 100%;
      div:first-child {
        font-family: PingFangSC-Regular;
        font-size: 1rem;
        color: #fe5845;
        letter-spacing: 0;
        line-height: 1.4rem;
      }
      div:last-child {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.4rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ordercell.vue